import "aos/dist/aos.css";
import React from "react";
import {useGlobalNotificationMessage} from "../context/message";
import {Button, Modal} from "react-bootstrap";

export default function GlobalNotificationMessage( {className, ...rest} ){
  const { message, removeMessage } = useGlobalNotificationMessage();
  const Btn = function ({button}) {
    return <button type="button" className={`btn ${button.className}`} onClick={'function' === typeof button.callback ? () =>{ button.callback(); removeMessage()} : undefined}>{button.label}</button>;
  };

  return (
    <>
      {message && <Modal show={!!message} onHide={removeMessage} centered contentClassName={'shadow'} >
        <Modal.Header closeButton>
          { message?.title && <Modal.Title>{ message?.title }</Modal.Title>}
        </Modal.Header>
        <Modal.Body className="text-center">
          <section>
            { message?.status === "danger" && <p className="text-danger"><span style={{"fontSize":"50pt"}} className="mdi mdi-alert-circle-outline text-large py-2"></span></p>}
            { message?.status === "success" && <p className="text-success"><span style={{"fontSize":"50pt"}} className="mdi mdi-check-circle-outline text-large py-2"></span></p>}
            <div dangerouslySetInnerHTML={{__html:message?.message}}></div>
            { message?.buttons?.length>0 && <div className={'mt-2'}>{message?.buttons.map(b=> {
              return <React.Fragment key={b.label}>
                {b.link && <><a href={b.link}><Btn button={b} /></a></>}
                {!b.link && <Btn button={b} />}
              </React.Fragment>;
            })}</div>}
          </section>
        </Modal.Body>
        <Modal.Footer>
          {message.actionBtnShow && message.actionBtnCallback && message.actionBtnText && <Button className={'me-2'} variant="primary" onClick={()=>message.actionBtnCallback()}>
            {message.actionBtnText}
          </Button>}
          {message.closeBtnShow && <Button className={`${message.closeBtnClassName}`} onClick={message.closeBtnCallback ? message.closeBtnCallback() : removeMessage}>
            {message.closeBtnText? message.closeBtnText : 'Close'}
          </Button>}
        </Modal.Footer>
      </Modal>}
    </>
  );
}
